import { render, staticRenderFns } from "./Value.vue?vue&type=template&id=3dae6324&scoped=true"
var script = {}
import style0 from "./Value.vue?vue&type=style&index=0&id=3dae6324&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae6324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dae6324')) {
      api.createRecord('3dae6324', component.options)
    } else {
      api.reload('3dae6324', component.options)
    }
    module.hot.accept("./Value.vue?vue&type=template&id=3dae6324&scoped=true", function () {
      api.rerender('3dae6324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/institutional-trading/components/Value.vue"
export default component.exports